// PUV
import React, { useEffect, useState, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GenericListPair from 'modules/common/components/GenericListPair';
import { ModalContext } from 'App';
import useDebounce from 'modules/common/components/UseDebounce';
import ApplicationContent from './ApplicationContent';
import * as actions from '../action';
import * as c from '../constant';

const form = {
  keyword: '',
  transaction_status: '',
  module_type: 'SPECIAL_PERMIT',
  type: "PUV"
};

const statusOptions = [
  { label: 'ALL', value: '' },
  { label: 'PENDING', value: 'PENDING' },
  { label: 'FOR CHECKING', value: 'FOR CHECKING' },
  { label: 'FOR ASSESSMENT (ADMIN)', value: 'FOR ASSESSMENT (ADMIN)' },
  { label: 'FOR ASSESSMENT (TREASURY)', value: 'FOR ASSESSMENT (TREASURY)' },
  { label: 'EXPIRED REFERENCE NUMBER', value: 'EXPIRED REFERENCE NUMBER' },
  { label: 'FINALIZED', value: 'FINALIZED' },
  { label: 'WAITING FOR PAYMENT', value: 'WAITING FOR PAYMENT' },
  { label: 'FOR PICK-UP', value: 'FOR PICK-UP' },
  { label: 'PRINTED', value: 'PRINTED' },
  { label: 'RECEIVED', value: 'RECEIVED' },
];

const ApplicationContainerPUV = ({
  getTransactionList,
  transactionList,
  transactionListPager,
  match,
  isLoading,
  history,
}) => {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(form);
  const [filter, setFilter] = useState(form);
  const [countChar, setCountChar] = useState(0);

  const UpdateData = () => {
    getTransactionList();
    return () => {
      setModal({ isOpen: false });
    };
  };

  useEffect(() => {
    UpdateData();
  }, []);

  const param = {
    module_type: 'SPECIAL_PERMIT',
    type: "PUV",
    q: formData.keyword,
    sort_by: 'asc',
  };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setCountChar(e.target.value.length);
  };

  const handleOnChangeSelect = (key) => (e) => {
    setFilter({
      ...filter,
      [key]: e.value,
      transaction_status: e.value,
    });
    getTransactionList({ ...filter, transaction_status: e.value });
  };

  const debouncedSearchTerm = useDebounce(formData, 500);

  useEffect(() => {
    if (debouncedSearchTerm && countChar >= 3) {
      getTransactionList({
        module_type: 'SPECIAL_PERMIT',
        type: 'PUV',
        q: formData.keyword,
      });
    } else {
      getTransactionList({
        module_type: 'SPECIAL_PERMIT',
        type: 'PUV',
      });
    }
  }, [debouncedSearchTerm]);

  const getExtName = (item) =>
    _.get(item, 'included.tax_payer.attributes.extension_name');

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Special Permit Applications"
            getData={getTransactionList}
            setParams={param}
            setKeyword={handleOnChange}
            setStatusFilter={handleOnChangeSelect(
              _.get(formData, 'transaction_status')
            )}
            status={_.get(filter, 'transaction_status') || ''}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search Application..."
            pathName={`${match.path}/:id?`}
            listName="Application"
            label="Application List"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="transaction-list-company">
                  {`${_.get(item, 'included.tax_payer.attributes.first_name')} ${_.get(item, 'included.tax_payer.attributes.middle_name') ||
                    ''
                    } 
                  ${_.get(item, 'included.tax_payer.attributes.last_name')}  ${getExtName(item) || ''
                    }`}
                </div>
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {_.get(item, 'included.tax_payer.attributes.mobile_number')}
                </h4>
              </div>
            )}
            statusOptions={statusOptions}
            isLoading={isLoading}
            statusFilter
            selected={params.id}
            data={transactionList}
            dataPager={transactionListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:id?`}
                    render={() => (
                      <ApplicationContent UpdateData={UpdateData} />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:id?`}
                  render={() =>
                    !params.business_Id && transactionList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(transactionList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
};

ApplicationContainerPUV.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  transactionList: PropTypes.instanceOf(Array).isRequired,
  transactionListPager: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionList: _.get(api, `${c.GET_TRANSACTION}.list`) || [],
  transactionListPager: _.get(api, `${c.GET_TRANSACTION}.pager`) || {},
  isLoading: api.loading.indexOf(c.GET_TRANSACTION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ApplicationContainerPUV);
